import { render, staticRenderFns } from "./RentabilidadeGrafico.vue?vue&type=template&id=31e27a37&scoped=true"
import script from "./RentabilidadeGrafico.vue?vue&type=script&lang=js"
export * from "./RentabilidadeGrafico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e27a37",
  null
  
)

export default component.exports